import React, { forwardRef } from "react";

type Props = {
  children: React.ReactNode;
  className?: string;
  gap?: number;
  justifyContent?: string;
  alignItems?: string;
  width?: string;
} & React.HTMLAttributes<HTMLDivElement>;

const VStack = forwardRef<HTMLDivElement, Props>(
  ({ children, className = "", gap, justifyContent, alignItems, width, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={`flex flex-col
          ${gap ? `gap-${gap}` : ""}
          ${justifyContent ? `justify-${justifyContent}` : ""}
          ${alignItems ? `items-${alignItems}` : "items-start"}
          ${className}`}
        {...props}
        style={{
          ...props.style,
          width: width ? width : "100%",
        }}
      >
        {children}
      </div>
    );
  }
);

export default VStack;
